import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class NewsPage extends BasePage {
    public static async init() {
        await super.init();

        this.setNewsPageAnalytics();
        this.setGallery();
    }

    public static setNewsPageAnalytics() {
        let ctas = document.querySelectorAll(".editor a");
        for (const item of ctas) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendCustomEvent("click", {internal_click_type: "news", internal_click_link: this.getAttribute("href")});
                }, false);
            }
        }
    }

    public static setGallery() {
        (<any>window).Fancybox.bind("[data-fancybox='gallery']", {
            dragToClose: false,
            Images: {
                zoom: false,
            },
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                },
            },
            Thumbs: {
                type: 'classic',
            },
        });
    }
}